if (!customElements.get('wlsn-modes')) {
  class WLSNModes extends HTMLElement {
    constructor() {
      super();

      this.classes = {
        activeClass: 'is-active',
        visibleClass: 'is-visible',
        interactedClass: 'is-interacted',
        trigger: 'js-wlsn-modes-trigger',
        panel: 'js-wlsn-modes-panel',
        pulse: 'js-wlsn-modes-pulse'
      };

      this.currentIndex = 0;
    }

    connectedCallback() {
      const { trigger, panel, pulse } = this.classes;

      this.triggers = Array.from(this.querySelectorAll(`.${trigger}`));
      this.panels = Array.from(this.querySelectorAll(`.${panel}`));
      this.pulseButton = this.querySelector(`.${pulse}`);

      if (!this.triggers.length) return;

      this.triggers.forEach((button) => {
        button.addEventListener('click', () => {
          this.dismissHint();
          this.select(Number(button.dataset.index));
        });
      });

      if (this.pulseButton) {
        this.pulseButton.addEventListener('click', () => {
          this.dismissHint();
        });
      }

      this.setActive(0);
    }

    dismissHint() {
      this.classList.add(this.classes.interactedClass);
    }

    select(index) {
      this.setActive(index);
    }

    setActive(index) {
      const { activeClass, visibleClass } = this.classes;

      this.currentIndex = index;

      this.triggers.forEach((button) => {
        const isActive = Number(button.dataset.index) === index;

        button.classList.toggle(activeClass, isActive);
        button.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      this.panels.forEach((element) => {
        const isVisible = Number(element.dataset.index) === index;

        element.classList.toggle(visibleClass, isVisible);
        element.setAttribute('aria-hidden', isVisible ? 'false' : 'true');
      });
    }
  }

  customElements.define('wlsn-modes', WLSNModes);
}
